class FacetRemove extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['link']
  }

  constructor () {
    super()
    if (this.context === 'nosto') {
      this.eventBus = window.theme.nosto.eventBus
      this.events = window.theme.results.events
    }
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.link.element, 'click', (event) => {
      event.preventDefault()

      if (this.context === 'nosto') {
        this.eventBus.publish(this.events.UI.FACET_REMOVED, {
          field: this.getAttribute('data-filter-label'),
          value: [this.getAttribute('data-filter-value')],
        })

        return
      }

      this.filters.onLinkClick(event)
    })
  }

  get context () {
    return this.dataset.context || 'shopify'
  }

  /**
   * @returns {CollectionFilters|null}
   */
  get filters () {
    return this.closest('collection-filters')
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove)
}
